import { createFileRoute } from '@tanstack/react-router';
import { requireWorkstation } from '../../../../utils/workstationGuard';
import { lazy, Suspense } from 'react';
import Loading from '../../../../pages/Loading/Loading';

const CreateTags = lazy(() => import('../../../../pages/PrintTagsTracking/CreateTags/CreateTags'));

export const Route = createFileRoute('/$lang/_authenticated/tags')({
  beforeLoad: requireWorkstation,
  component: () => (
    <Suspense fallback={<Loading />}>
      <CreateTags />
    </Suspense>
  ),
});
